import { ConvertedImageRaw, OneShotBinary } from '../../types';

import { ChallengeSaveError } from '../../../types';
import { isNodeWithSize } from '../../utils/isNodeWithSize';
import { createCoreMethod } from '../../utils/createCoreMethod';

export const getSelectedNodeImage = createCoreMethod(
  'getSelectedNodeImage',
  async (): Promise<ConvertedImageRaw | ChallengeSaveError> => {
    const node = figma.currentPage.selection[0];

    if (!node || !isNodeWithSize(node)) {
      return {
        type: 'NODE_NOT_FOUND',
      };
    }

    if (node.height / node.width > 10)
      return { type: 'IMAGE_TOO_BIG', nodeId: node.id, nodeName: node.name };

    try {
      const converted = await node.exportAsync({
        format: 'PNG',
        useAbsoluteBounds: true,
        contentsOnly: true,
      });

      return { converted: new OneShotBinary(converted).take() };
    } catch {
      return {
        type: 'UNABLE_TO_GENERATE_IMAGE',
        nodeId: node.id,
        nodeName: node.name,
      };
    }
  }
);
